module.exports = __webpack_public_path__ + "static/media/splash.6847a248.mp3";